<script lang="ts">
    import PageComposer from '$src/lib/components/PageBuilder/PageComposer.svelte';
    export let data;
</script>

<PageComposer page={data.pageData} debug={data.debugMode} />
